{
  "title": "Fast Friends",
  "source": "Acquisitions Inc.",
  "levelAndSchool": "3rd-level enchantment",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "When you cast this spell, choose one humanoid within range that can see and hear you, and that can understand you. The creature must succeed on a Wisdom saving throw or become charmed by you for the duration. While the creature is charmed in this way, it undertakes to perform any services or activities you ask of it in a friendly manner, to the best of its ability.",
    "You can set the creature new tasks when a previous task is completed, or if you decide to end its current task. If the service or activity might cause harm to the creature, or if it conflicts with the creature's normal activities and desires, the creature can make another Wisdom saving throw to try to end the effect. This save is made with advantage if you or your companions are fighting the creature. If the activity would result in certain death for the creature, the spell ends.",
    "When the spell ends, the creature knows it was charmed by you.",
    "At Higher Levels: When you cast this spell using a spell slot of 4th level or higher, you can target one additional creature for each slot level above 3rd.",
    "Spell Lists: Bard, Cleric, Wizard"
  ],
  "spellLists": ["bard", "cleric", "arcane-trickster", "wizard"]
}
